import type { CertificationType } from '../../../types/program';

// ─── Step Types ──────────────────────────────────────────────────────────

export type ProgramWizardStepNumber = 1 | 2 | 3;
export type StepStatus = 'pending' | 'saved' | 'active';

export interface ProgramDetailsData {
  name: string;
  description?: string | null;
  headerImageKey?: string | null;
  durationDays: number;
  certificationType: CertificationType;
  certificateFileKey?: string | null;
}

export interface ProgramWizardStepState {
  status: StepStatus;
}

export interface ProgramWizardState {
  programId: string | null;
  steps: Record<ProgramWizardStepNumber, ProgramWizardStepState>;
}

// ─── Constants ───────────────────────────────────────────────────────────

export const PROGRAM_STEP_LABELS: Record<ProgramWizardStepNumber, string> = {
  1: 'Basics',
  2: 'Content',
  3: 'Certification',
};

export const PROGRAM_STEP_DESCRIPTIONS: Record<ProgramWizardStepNumber, string> = {
  1: 'Set the name, description, duration, and cover image.',
  2: 'Schedule courses across each day of the program.',
  3: 'Choose how learners receive their certificate.',
};

export const PROGRAM_ALL_STEPS: ProgramWizardStepNumber[] = [1, 2, 3];

// ─── Certification type labels ───────────────────────────────────────────

export const CERTIFICATION_TYPE_LABELS: Record<CertificationType, string> = {
  none: 'None',
  auto_generated: 'Auto-generated',
  custom_upload: 'Upload PDF',
};
